import { AlertSpg, GridContainer, GridItem, ViewSection } from "@duosoftbg/nacid-components";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";
import ScrollableGridContainer from "../../../../common/grid/ScrollableGridContainer";

const RoleGroupUsersDisplay = ({ role }) => {
  const { t } = useTranslation();

  return (
    <ViewSection label={"t.role.groupUsers"}>
      <ScrollableGridContainer>
        {role.groupUsers && Object.keys(role.groupUsers).length > 0 ? (
          Object.keys(role.groupUsers).map((key) => (
            <GridItem sm={12} md={12} key={key} pl={8} pr={0}>
              <GridContainer spacing={3} mt={0}>
                <GridItem sm={12} md={12}>
                  <Typography variant={"h6"} fontStyle={"italic"} sx={{ textDecoration: "underline" }}>
                    {key}
                  </Typography>
                </GridItem>
                {role.groupUsers[key]
                  ? role.groupUsers[key].map((user) => (
                      <GridItem sm={6} md={4} key={user.id}>
                        {user}
                      </GridItem>
                    ))
                  : null}
              </GridContainer>
            </GridItem>
          ))
        ) : (
          <GridItem sm={12} md={12} lg={12} paddingLeft={"10px"}>
            <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>
          </GridItem>
        )}
      </ScrollableGridContainer>
    </ViewSection>
  );
};
export default RoleGroupUsersDisplay;
